import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, flatMap, mergeMap, switchMap } from 'rxjs/operators';
import * as fromShared from '../../../shared';
import {
    DisplayMessageMinimum,
    IStatusMessage,
    ResponseStatus
} from '../../../shared';
import { TaskTimerService } from '../../task-timer.service';
import * as HistoryActions from './task-timer-history.actions';
import moment from 'moment';

@Injectable()
export class TaskTimerHistoryEffects {
    constructor(private actions$: Actions, private service: TaskTimerService) {}

    post$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(HistoryActions.postTaskTimerHistory),
            switchMap(a =>
                this.service.post(a.StartDate, a.EndDate).pipe(
                    flatMap(resp => [
                        HistoryActions.loadTaskTimerHistorys({
                            TaskTimerHistorys: JSON.parse(resp)
                        })
                    ]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });

    // put$ = createEffect(() =>
    //     this.actions$.pipe(
    //         ofType(TimerActions.putTaskTimer),
    //         switchMap(a =>
    //             this.service.put(a.JsonString).pipe(
    //                 flatMap(c => [
    //                     // TimerActions.updateTaskTimers({
    //                     //     taskTimers: [
    //                     //         {
    //                     //             id: `${JSON.parse(c)[0].empauthid}-${JSON.parse(c)[0].timerid}`,
    //                     //             changes: JSON.parse(c)[0]
    //                     //         }
    //                     //     ]
    //                     // }),
    //                     TimerActions.upsertTaskTimers({
    //                         taskTimers: JSON.parse(c)
    //                     })

    //                 ]),
    //                 catchError(fromShared.Errors.handleServiceError)
    //             )
    //         )
    //     )
    // );
}
